import styled from 'styled-components';

import { colors } from 'assets/styles/commonStyle';

export const LineProgressBar = styled.div`
  position: relative;
  padding: 0 3rem;
`;

export const BodyContainer = styled.div<{ disabled?: boolean }>`
  position: relative;
  margin: 3rem 0;
  opacity: ${({ disabled }) => (disabled ? '0.4' : '1')};
`;

export const ProgressHeader = styled.div`
  display: grid;
  grid-template-columns: 100px auto 100px;
  grid-gap: 10px;
  align-items: center;
  margin-bottom: 15px;
  min-height: 60px;
  text-align: center;
`;

export const ProgressHeaderDate = styled.div<{ textAlign?: string }>`
  font-size: 8px;
  line-height: 14px;
  letter-spacing: 0.5px;
  color: ${colors.colorGrayDark};
  padding: 0 10px;
  position: relative;
  min-height: 26px;
  text-align: ${({ textAlign }) => (textAlign ? textAlign : 'center')};
`;

export const ProgressBarContainer = styled.div`
  padding: 1rem 0;
`;

export const ProgressBar = styled.div`
  position: absolute;
  z-index: 1;
  right: 0;
  left: 0;
  height: 8px;
  transform: translateY(-50%);
  background: ${colors.colorGray};
  border-radius: 4px;
`;

export const ProgressLine = styled.div`
  position: absolute;
  z-index: 2;
  left: 0;
  height: 6px;
  transform: translateY(-50%);
  background: ${colors.base};
  border-radius: 3px;
  transition: width 0.5s ease;
`;

export const TiersContainer = styled.div`
  display: flex;
  position: absolute;
  height: 100%;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const TierItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 2;
  position: absolute;
  &:hover {
    z-index: 100;
  }
`;

export const TierHeader = styled.div`
  position: absolute;
  transform: translateY(-100%);
  width: max-content;
`;

export const ForcedLabel = styled.div`
  position: relative;
  background: ${colors.colorBlue};
  border-radius: 2px;
  line-height: 1.2;
  color: ${colors.white};
  display: block;
  padding: 6px 5px;
  margin: 0;
  font-size: 10px;
  text-transform: uppercase;
  text-align: center;
`;

export const TierTitle = styled.div<{ isActive?: boolean }>`
  font-size: 14px;
  font-weight: 500;
  line-height: 1.15;
  color: ${({ isActive }) => (isActive ? 'rgba(0, 0, 0, 1)' : 'rgba(0, 0, 0, 0.35)')};
  background: ${colors.white};
  padding: 3px;
  text-align: center;
  margin-bottom: 0;
  max-width: 100px;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  &:hover {
    overflow: visible;
    white-space: unset;
    max-width: 200px;
  }
`;

export const TierMarker = styled.div<{ isActive?: boolean }>`
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: ${({ isActive }) => (isActive ? colors.base : colors.colorGrayLite)};
  z-index: 3;
  transition: background 0.5s ease;
`;

export const RangeContainer = styled.div`
  background: ${colors.base};
  border-radius: 1px;
  text-align: center;
  color: ${colors.white};
  white-space: nowrap;
  font-size: 10px;
  padding: 3px 5px;
  display: inline-block;
  max-width: 90px;
  white-space: nowrap;
  overflow: hidden;
  display: block;
  text-overflow: ellipsis;
  &:hover {
    overflow: visible;
    max-width: unset;
  }
`;

export const TierFooter = styled.div`
  position: absolute;
  transform: translateY(100%);
`;

export const UserCurrentTier = styled.div`
  display: inline-grid;
  grid-template-columns: 40px auto;
  grid-gap: 15px;
  align-items: center;
  padding: 10px 15px;
  min-width: 220px;
  text-align: left;

  ${({ color }) => {
    switch (color) {
      case 'gold':
        return `
          background: ${colors.colorGold};
          border-left: 2px solid ${colors.base};

          svg {
            color: ${colors.base};
          }
    `;
      case 'blue':
        return `
         background: ${colors.colorAzure};
         border-left: 2px solid ${colors.colorBlueLite};

          svg {
            color: ${colors.colorBlueLite};
          }
        `;
    }
  }}
`;

export const CurrentTierContent = styled.div`
  font-size: 10px;
  line-height: 10px;
  font-weight: bold;
  color: ${colors.colorGrayDark};
  margin: 0;

  span {
    text-transform: uppercase;
  }

  strong {
    display: block;
    font-size: 25px;
    line-height: 25px;
    font-weight: bold;
    text-transform: uppercase;
    padding-top: 5px;
  }
`;

export const ProgressFooter = styled.div`
  text-align: center;

  hr {
    display: block;
    border: none;
    margin: 30px auto;
    padding: 0;
    max-width: 220px;
    height: 1px;
    background: ${colors.colorGrayLine};
  }
`;

export const FooterForced = styled.div`
  margin-bottom: 0.5rem;
`;

export const DeleteLink = styled.a`
  color: ${colors.base} !important;
  transition: opacity 0.3s ease;
  display: inline-block;
  position: relative;
  padding-left: 25px;
  line-height: 22px;

  svg {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  &:hover {
    opacity: 0.5;
  }
`;

export const BlueBgBox = styled.div`
  display: inline-block;
  background: ${colors.colorAzure};
  font-weight: bold;
  padding: 6px 12px;
  border-radius: 2px;
  margin: 0 5px;
`;
